import Settings from './settings';
import Solutions from './solutions/index.js';
import Locations from './locations';
import Devices from './devices';
import Integrations from './integrations';
import Assets from './assets';

import './styles.scss';

export default { Settings, Solutions, Locations, Devices, Integrations, Assets };
